export default {
    rowHider: function (element) {
        element.closest(".field-row").hide();
    },
};
